import * as React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import nl from "date-fns/locale/nl";
import { BaseConsumer } from "../03-base/Base";
registerLocale("nl", nl);
var onChangeDate = function (date, onChange) {
    if (!!onChange) {
        onChange(date ? moment(date).format("YYYY-MM-DD") : undefined);
    }
};
/**
 *
 * @param props
 */
export var DateInput = function (props) {
    var inputRef = React.useRef(null);
    var handleKeyDown = function (e) {
        var _a;
        if (e.code === "Tab") {
            return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
        }
    };
    return (React.createElement(BaseConsumer, null, function (_a) {
        var _b, _c;
        var getLanguage = _a.getLanguage;
        return (React.createElement(DatePicker, { ref: inputRef, selected: !!props.value && typeof props.value === "string" ? new Date(props.value) : undefined, dateFormat: (_b = props.dateFormat) !== null && _b !== void 0 ? _b : "dd-MM-yyyy", onChange: function (value) { return onChangeDate(value, props.onChange); }, className: props.className, isClearable: !!props.disabled ? false : true, placeholderText: (_c = props.placeholderText) !== null && _c !== void 0 ? _c : "DD-MM-JJJJ", popperPlacement: props.popperPlacement || "top", minDate: props.minDate, maxDate: props.maxDate, disabled: !!props.disabled, required: props.required, locale: getLanguage() === "nl" ? getLanguage() : undefined, strictParsing: true, onKeyDown: handleKeyDown, enableTabLoop: false }));
    }));
};
export var testUtil = {
    onChangeDate: onChangeDate,
};
